// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--11zf8","title_text":"styles-module--title_text--1ir3t","footer_item":"styles-module--footer_item--3l_5Q"};